export default "__VITE_ASSET__c4ed18c7__"